import {
  pilingMachineQuery,
  pilingMachineListQuery,
} from '../graphql/piling_machine_queries';
import cleanCache from './clean_cache';

export const pilingMachineList = (client, listData) => {
  listData.map((pilingMachine) => {
    const data = { pilingMachine };
    return client.writeQuery({
      query: pilingMachineQuery,
      variables: { id: pilingMachine.id.toString() },
      data,
    });
  });
  cleanCache(client.cache);
};

export const pilingMachineCreate = (
  cache,
  { data: { pilingMachineCreate: createData } }
) => {
  let cacheData;
  try {
    cacheData = cache.readQuery({ query: pilingMachineListQuery });
  } catch {
    cacheData = { pilingMachineList: [] };
  }
  if (!cacheData) {
    cacheData = { pilingMachineList: [] };
  }
  cache.writeQuery({
    query: pilingMachineListQuery,
    data: { pilingMachineList: [...cacheData.pilingMachineList, createData] },
  });
  const data = { pilingMachine: createData };
  cache.writeQuery({
    query: pilingMachineQuery,
    variables: { id: createData.id.toString() },
    data,
  });
  cleanCache(cache);
};

export const pilingMachineUpdate = (
  cache,
  { data: { pilingMachineUpdate: updateData } }
) => {
  const data = { pilingMachine: updateData };
  cache.writeQuery({
    query: pilingMachineQuery,
    variables: { id: updateData.id.toString() },
    data,
  });
  cleanCache(cache);
};

export const pilingMachineDelete = (
  cache,
  { data: { pilingMachineDelete: deleteData } }
) => {
  let cacheData;
  try {
    cacheData = cache.readQuery({ query: pilingMachineListQuery });
  } catch {
    cacheData = { pilingMachineList: [] };
  }
  if (!cacheData) {
    cacheData = { pilingMachineList: [] };
  }
  const data = {
    pilingMachineList: cacheData.pilingMachineList.filter(
      (pilingMachine) => deleteData.id !== pilingMachine.id
    ),
  };
  cache.writeQuery({ query: pilingMachineListQuery, data });
  cache.evict({ fieldName: 'pilingMachine', args: { id: deleteData.id.toString() } });
  cleanCache(cache);
};
